export enum PermissionEnum {
  Visualizar = 1,
  Add,
  Edit,
  Export
}
